<div class="midni-scanner">
	@if (instructionI18nKey) {
		<span class="midni-scanner__instruction" [innerHTML]="instructionI18nKey | translate"></span>
	}
	<div class="midni-scanner__viewport">
		@for (v of [videoRemountVersion]; track v) {
			<div class="midni-scanner__video-root">
				<app-video
					[debugMode]="false"
					[animationFrame]="0"
					[constraints]="constraints"
					[forceFlipHorizontal]="true"
					[zoomFactor]="1"
					[zoomOffsetX]="0"
					[zoomOffsetY]="0"
					(cameraError)="onCameraError($event)"
					(cameraPermissionRevoked)="onCameraPermissionRevoked()"
					(cameraStarted)="onCameraStarted($event)"
				/>
			</div>
		}
		<canvas #canvasEl class="midni-scanner__canvas"></canvas>
		@if (scanning) {
			<div class="midni-scanner__frame"></div>
		}
		@if (!cameraReady) {
			<div class="midni-scanner__loading">
				<tec-spinner size="sm" />
			</div>
		}
	</div>
	@if (errorMsg) {
		<p class="midni-scanner__error">{{ errorMsg }}</p>
	}
</div>
